import { render, staticRenderFns } from "./BirdVisualizer.vue?vue&type=template&id=77fa59ab&scoped=true&"
import script from "./BirdVisualizer.vue?vue&type=script&lang=js&"
export * from "./BirdVisualizer.vue?vue&type=script&lang=js&"
import style0 from "./BirdVisualizer.vue?vue&type=style&index=0&id=77fa59ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fa59ab",
  null
  
)

export default component.exports